<template>
  <main class="layout__main">
    <section class="section mt-0">
      <div class="container" v-show="ready">
        <div class="page-steps">
          <div class="page-steps__wrap">
            <div class="page-steps__container">
              <div
                class="page-steps__item"
                v-for="(item, i) in steps"
                :key="item.id"
              >
                <div
                  class="page-step"
                  :class="{
                  'page-step_active': step === item.id,
                  'page-step_done': done.indexOf(item.id) !== -1,
                }"
                >
                  <div
                    class="page-step__button"
                    @click.prevent="done.indexOf(item.id) !== -1 ? setStep(item.id) : null"
                  >
                    <div class="page-step__icon">
                      <span class="page-step__icon-num">{{ i + 1 }}</span>
                      <icon
                        class="page-step__icon-svg"
                        icon-name="check-bold"
                      >
                      </icon>
                    </div>
                    <div class="page-step__name">{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container container_mobile" v-if="ready">
        <keep-alive>
          <champ-info
            :club="club"
            v-if="step === 'info'"
            :champId="champId"
            :champ="champ"
            @next="setStep('nominations', true)"
            @changed="saveChampInfo"
          ></champ-info>
          <champ-nominations
            :club="club"
            v-if="step === 'nominations'"
            :champId="champId"
            @prev="setStep('info')"
            @next="setStep('stages', true)"
            @changed="saveNominations"
          ></champ-nominations>
          <champ-stages
            :club="club"
            :champ="champ"
            v-if="step === 'stages'"
            :champId="champId"
            @prev="setStep('nominations')"
            @next="setStep('publish', true)"
            @changed="saveChampStages"
          ></champ-stages>
        </keep-alive>
        <champ-publish
          v-if="step === 'publish'"
          :champ="champ"
          @prev="setStep('stages')"
        >
        </champ-publish>
      </div>
      <div class="loader m-0" v-else></div>
    </section>
  </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import champsService from '@/services/champsService'
import ChampInfo from './CreateChamp/ChampInfo.vue'
import ChampNominations from './CreateChamp/ChampNominations.vue'
import ChampStages from './CreateChamp/ChampStages.vue'
import ChampPublish from './CreateChamp/ChampPublish.vue'

export default {
  name: 'CreateChamp',
  components: {
    ChampInfo,
    ChampNominations,
    ChampStages,
    ChampPublish
  },
  data () {
    return {
      step: 'info',
      done: [],
      allSteps: ['info', 'nominations', 'stages', 'publish'],
      steps: [
        {
          id: 'info',
          name: 'Основная информация'
        },
        {
          id: 'nominations',
          name: 'Номинации'
        },
        {
          id: 'stages',
          name: 'Этапы'
        }
      ],
      club: null,
      champId: null,
      champ: {},
      ready: false
    }
  },
  computed: {
    ...mapState('club', ['clubCode', 'clubInfo']),
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    },
    isLoaded () {
      return this.clubInfo && this.clubCode === this.idClub
    }
  },
  methods: {
    ...mapActions('club', ['getClubInfo']),
    setClub (data) {
      const d = data || this.clubInfo

      this.club = {
        id: d.id,
        name: d.name,
        logo: d.logoUrl
      }
    },
    setStep (id, next) {
      if (next && this.done.indexOf(this.step) === -1) {
        this.done.push(this.step)
      }
      if (this.step === id) {
        return
      }
      this.step = id
      this.$router.replace({
        query: {
          step: this.step
        }
      })
      window.scrollTo(0, 0)
    },
    saveChampInfo (data) {
      this.champId = data.champId
      this.champ.Name = data.name
      this.champ.StartDate = data.startDate
      this.champ.FinishDate = data.finishDate
      this.champ.DisciplineCode = data.discipline
      this.champ.DisciplineName = data.disciplineName
      this.champ.Code = data.code
      this.champ.Id = data.champId
    },
    saveNominations (count) {
      this.champ.NominationsCount = count
    },
    saveChampStages (data) {
      this.champ.TotalStagesCount = data.total
      this.champ.CompletedStagesCount = data.completed
    },
    checkInitialStep () {
      this.done = ['info']

      if (this.champ.NominationsCount > 0) {
        this.done.push('nominations')
      }
      if (this.champ.TotalStagesCount > 0) {
        this.done.push('stages')
      }

      const step = this.$route.query.step

      if (step === 'stages' || step === 'publish') {
        if (this.done.indexOf('nominations') !== -1) {
          this.step = step
        }
      }

      this.ready = true
    },
    getChamp () {
      champsService.getChamps({
        clubId: this.club.id,
        championshipsType: 1,
        onlyActive: false,
        onlyOneId: this.champId,
        showDrafts: true,
        skip: 0,
        take: 1
      })
        .then((res) => {
          if (res.data.Championships.length > 0) {
            this.champ = res.data.Championships[0] || {}
            this.checkInitialStep()
          } else {
            this.$router.replace({
              params: { champ: null }
            })
            this.ready = true
          }
        })
        .catch(() => {
          this.$router.replace({
            params: { champ: null }
          })
          this.ready = true
        })
    }
  },
  watch: {
    isLoaded: {
      handler (val) {
        if (!val) {
          return
        }
        if (!this.clubInfo.isManager) {
          this.$router.replace({ name: 'Home' })
          return
        }
        this.champId = this.$route.params.champ
        this.setClub()
        if (this.champId) {
          this.getChamp()
        } else {
          this.ready = true
        }
      },
      immediate: true
    }
  },
  created () {
    this.champId = this.$route.params.champ
    this.getClubInfo(this.$route.params.id || this.$getTenantIdClub())
  }
}
</script>

<style lang="scss" scoped>
  .page-steps {
    max-width: 690px;

    @media (max-width: 690px) {
      width: auto;
      max-width: none;
      margin-left: -16px;
      margin-right: -16px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
</style>

<style lang="scss">
  .page-steps {
    @include text-md;
    font-weight: 400;
    width: 100%;
    margin: 0 auto 16px;
    overflow-y: hidden;

    &__container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__item {
      flex: 1 0 auto;
      margin-right: 8px;

      &:last-child {
        flex-grow: 0;
      }
    }
  }

  .page-step {
    display: flex;
    align-items: center;
    color: map-get($color-neutral-black, 45);

    &::after {
      flex: 1 1 100%;
      content: "";
      width: 100%;
      min-width: 64px;
      height: 1px;
      background-color: map-get($color-neutral-black, 25);
      margin-left: 8px;
    }

    .page-steps__item:last-child &::after {
      content: none;
    }

    &_done {
      font-weight: inherit;
      color: inherit;

      &::after {
        background-color: $color-primary;
      }
    }

    &_active {
      font-weight: $font-weight-semibold;
      color: inherit;
    }

    &__button {
      flex: 0 0 auto;
      display: flex;
      align-items: center;

      .page-step_done & {
        cursor: pointer;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid map-get($color-neutral-black, 25);
      font-size: 14px;
      line-height: 1;
      font-weight: $font-weight-semibold;
      text-align: center;
      margin-right: 8px;

      .page-step_done & {
        background-color: transparent;
        border-color: $color-primary;
        color: $color-primary;
      }

      .page-step_active & {
        background-color: $color-primary;
        border-color: transparent;
        color: $color-white;
      }
    }

    &__icon-svg {
      display: none;
      width: 12px;
      height: 12px;

      .page-step_done & {
        display: block;
      }

      .page-step_active & {
        display: none;
      }
    }

    &__icon-num {
      display: block;

      .page-step_done & {
        display: none;
      }

      .page-step_active & {
        display: block;
      }
    }

    &__name {
      flex: 0 0 auto;
    }
  }
</style>
